const config = {};

export default config;
function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
function load() {
  let url = `${window.location.origin}/`;

  if (inIframe()) {
    if (process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '/') {
      url = process.env.PUBLIC_URL;
    }
  }
  return fetch(`${url}config.json`)
    .then(result => result.json())
    .then(newconfig => {
      // eslint-disable-next-line guard-for-in
      for (const prop in config) {
        delete config[prop];
      }
      // eslint-disable-next-line guard-for-in
      for (const prop in newconfig) {
        config[prop] = newconfig[prop];
      }
      return config;
    });
}
export { load };
